<template>
  <div id="app">
    <a-spin tip="กำลังโหลดข้อมูล..." :spinning="$store.state.isLoading" size="large">
      <router-view></router-view>
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.handleResize)
      window.visualViewport.addEventListener('scroll', this.handleResize)
    }
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.handleResize)
      window.visualViewport.removeEventListener('scroll', this.handleResize)
    }
  },
  methods: {
    handleResize () {
      const innerH = window.innerHeight || 0
      const innerW = window.innerWidth || 0
      const clientH = document.documentElement ? document.documentElement.clientHeight : 0
      const vv = window.visualViewport
      let h = Math.max(innerH, clientH)
      if (vv && typeof vv.height === 'number' && vv.height > 0) {
        h = Math.max(h, Math.round(vv.height))
      }
      this.$store.state.screenHeight = Math.max(320, h)
      let w = innerW
      if (vv && vv.width > 0) {
        w = Math.max(innerW, Math.round(vv.width))
      }
      this.$store.state.screenWidth = w
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue